import React, { useEffect, useRef, useState } from "react";
import { CgProfile } from "react-icons/cg";
import { AiOutlineDollar } from "react-icons/ai";
import { GoPeople } from "react-icons/go";
import { IoLogOutOutline, IoSettingsOutline } from "react-icons/io5";
import EditIcon from "./spotmies llp";
import AnotherAccount from "./another account";
import SaveChanges from "./savechanges";
import TotalCredits from "./totalcredits";
import AddMember from "./addmember";
import Inputtext from "./spotmies";
import Email from "./Email";
import Remaining from "./remaining";
import Enable from "./enable2 factor";
import ChangePasswordForm from "./changepassword";
import DisableAccount from "./diableaccount";
import DeleteAccount from "./deleteaccount";
import { IoIosAddCircleOutline } from "react-icons/io";
import Addnumber from "./newnumber";
import { BsPeople } from "react-icons/bs";
import Socialmediapopup from "./socialmediapopup";
import { MdOutlineDeleteOutline } from "react-icons/md";
import ConfirmationPopup from "./confirmationpopup";
import HistoryJobpostCard from "../../dashboard/history/historyJobpostCard";
import { useStores } from "../../../store";
import { toJS } from "mobx";
import { uploadFileToAzure } from "../../../services/azure";
import ViewCredits from "../../dashboard/viewCredits";
import TeamsTable from "./teamstable";
import KnowMorePopup from "./knowmorepopup";
import { FiAlertCircle } from "react-icons/fi";
import NotificationSettingComponent from "./Email";
import { useObserver } from "mobx-react";
import PreviousSubscription from "../Pricing/previousSubscription";
import { logout } from "../../../api/api_methods";
const FormField = ({
  label,
  id,
  type,
  placeholder,
  inputRef,
  disabled,
  maxLength,
}) => {
  return (
    <div>
      <label
        htmlFor={id}
        className="text-[#888888] font-medium block mb-2 ml-1"
      >
        {label}
      </label>
      <input
        id={id}
        type={type}
        placeholder={placeholder}
        ref={inputRef}
        disabled={disabled}
        maxLength={maxLength}
        className="w-full md:w-[27vw] px-4 py-2 border border-gray-300 text-[#000000] rounded-md focus:outline-none focus:ring-1 focus:ring-[#FF6B00]"
      />
    </div>
  );
};

const ProfilePage1 = () => {
  const [activeTab, setActiveTab] = useState("profile");
  const [isLoading, setIsLoading] = useState(false);
  const [addNewInput, setAddNewInput] = React.useState(false);
  const [user, setUser] = useState({});
  const { UserStore, PopupStore, RecuiterStore } = useStores();
  const [profile, setProfile] = useState("");
  const [socialMedia, setSocialMedia] = useState([]);
  const [socialMediaIndex, setSocialMediaIndex] = useState(null);
  const [previousData, setPreviousData] = useState(null);

  const nameInputRef = useRef(null);
  const UsernameInputRef = useRef(null);
  const addressInputRef = useRef(null);
  // const linkedInRef = useRef(null);
  const cityInputRef = useRef(null);
  const IndustryInputRef = useRef(null);
  const designationInputRef = useRef(null);
  const telephoneInputRef = useRef(null);
  const emailInputRef = useRef(null);
  const linkedInInputRef = useRef(null);
  const websiteInputRef = useRef(null);
  // const fileInputRef = useRef(null);
  const formFields = [
    {
      label: "Company Name",
      id: "company-name",
      type: "text",
      placeholder: "Spotmies LLP",
      ref: nameInputRef,
    },
    {
      label: "Name",
      id: "person-name",
      type: "text",
      placeholder: "John Doe",
      ref: UsernameInputRef,
    },
    {
      label: "Industry Type",
      id: "industry-type",
      type: "text",
      placeholder: "Software/IT",
      ref: IndustryInputRef,
    },
    {
      label: "Designation",
      id: "designation",
      type: "text",
      placeholder: "Software Engineer",
      ref: designationInputRef,
    },
    {
      label: "Website",
      id: "website",
      type: "text",
      placeholder: "www.spotmies.com",
      ref: websiteInputRef,
    },
    {
      label: "Email-ID",
      id: "email",
      type: "email",
      placeholder: "connect@spotmies.com",
      ref: emailInputRef,
      disabled: true,
    },
    {
      label: "Mobile no",
      id: "mobile-no",
      type: "text",
      placeholder: "+91 8801462232",
      ref: telephoneInputRef,
      maxLength: 12,
    },
    {
      label: "Location",
      id: "location",
      type: "text",
      placeholder: "Visakhapatnam",
      ref: addressInputRef,
    },
    {
      label: "LinkedIn",
      id: "linkedIn",
      type: "text",
      placeholder: "linked.in",
      ref: linkedInInputRef,
    },
  ];

  const autoFillRef = () => {
    if (nameInputRef.current)
      nameInputRef.current.value = user?.companyName ?? "";
    if (UsernameInputRef.current)
      UsernameInputRef.current.value = user?.name ?? "";
    if (addressInputRef.current)
      addressInputRef.current.value = user?.address ?? "";
    if (cityInputRef.current) cityInputRef.current.value = user?.city ?? "";
    if (IndustryInputRef.current)
      IndustryInputRef.current.value = user?.industry ?? "";
    if (designationInputRef.current)
      designationInputRef.current.value = user?.designation ?? "";
    if (telephoneInputRef.current)
      telephoneInputRef.current.value = user?.mobile ?? "";
    if (emailInputRef.current) emailInputRef.current.value = user?.mail ?? "";
    if (linkedInInputRef.current)
      linkedInInputRef.current.value = user?.linkedIn ?? "";
    if (websiteInputRef.current)
      websiteInputRef.current.value = user?.websiteURL ?? "";
    if (user?.socialMediaAccounts?.length > 0) {
      setSocialMedia(user?.socialMediaAccounts);
    }
  };

  useEffect(() => {
    autoFillRef();
  }, [user, activeTab]);

  const submitHandler = async (e) => {
    e.preventDefault();
    // const linkedin=socialMedia.find((item)=>item?.platform==="Linkedin");
    // if(linkedin?.userId===""){
    //   alert("Please fill linkedin details");
    //   return;
    // }
    const name = nameInputRef.current.value;
    const username = UsernameInputRef.current.value;
    const address = addressInputRef?.current.value;
    const industry = IndustryInputRef.current.value;
    const designation = designationInputRef.current.value;
    const telephone = telephoneInputRef.current.value;
    const email = emailInputRef.current.value;
    const website = websiteInputRef.current.value;
    const linkedIn = linkedInInputRef.current
      ? linkedInInputRef.current.value
      : "";

    if (
      nameInputRef.current.value == user?.companyName &&
      UsernameInputRef.current.value == user?.name &&
      addressInputRef.current.value == user?.address &&
      IndustryInputRef.current.value == user?.industry &&
      designationInputRef.current.value == user?.designation &&
      telephoneInputRef.current.value == user?.mobile &&
      emailInputRef.current.value == user?.mail &&
      websiteInputRef.current.value == user?.websiteURL &&
      linkedInInputRef.current.value == user?.linkedIn &&
      UserStore.userPic == user?.pic &&
      JSON.stringify(socialMedia) ==
        JSON.stringify(user?.socialMediaAccounts) &&
      profile == (user?.pic || "")
    ) {
      alert("No changes made");
      return;
    } else {
      console.log(
        {
          name: nameInputRef.current.value,
          username: UsernameInputRef.current.value,
          address: addressInputRef.current.value,
          industry: IndustryInputRef.current.value,
          designation: designationInputRef.current.value,
          telephone: telephoneInputRef.current.value,
          email: emailInputRef.current.value,
          website: websiteInputRef.current.value,
        },
        {
          name: user?.companyName,
          username: user?.name,
          address: user?.address,
          industry: user?.industry,
          designation: user?.designation,
          telephone: user?.mobile,
          email: user?.mail,
          website: user?.websiteURL,
          linkedIn: user?.linkedIn,
        },
        "these are the changes",
      );
    }
    if (!email.includes("@")) {
      alert("Please enter a valid email address.");
      return;
    }
    // const linkedIn = linkedInInputRef.current.value;
    // const username = UsernameInputRef.current.value;
    console.log(
      name,
      username,
      address,
      designation,
      industry,
      telephone,
      email,
    );
    console.log(toJS(UserStore.userDetails));
    let body = {
      name: username,
      companyName: name,
      address: address,
      websiteURL: website,
      socialMediaAccounts: socialMedia,
      // city: city,
      industry: industry,
      designation: designation,
      mobile: telephone,
      mail: email,
      linkedIn: linkedIn,
      pic: UserStore.userPic,
      // pic: profile,
    };
    setIsLoading(true);
    await UserStore.updateUserDetailsToServer(body);
    setUser(UserStore.userDetails);
    alert("profile updated successfully");
    setIsLoading(false);
  };
  const userDetail = localStorage.getItem("user");

  const [subscriptions, setSubscriptions] = useState([]);

  useEffect(() => {
    const fetchProfile = async () => {
      await UserStore.getUserDetails(true);
      setUser(UserStore.userDetails);
      setProfile(UserStore.userDetails?.pic || "");
    };
    fetchProfile();
    const loadSub = async () => {
      const sub = await UserStore.checkSubscription();
      setSubscriptions(sub);
    };
    loadSub();
  }, []);

  const [showAddNumberPopup, setShowAddNumberPopup] = useState(false);
  const [showSocialMediaPopup, setShowSocialMediaPopup] = useState(false);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [showLogConfirmationPopup, setShowLogConfirmationPopup] =
    useState(false);
  const [showRemoveConfirmationPopup, setShowRemoveConfirmationPopup] =
    useState(false);

  const getUserSetting = (settingName) => {
    return Array.isArray(user?.additionalSettings)
      ? user.additionalSettings.find((setting) => setting?.name === settingName)
          ?.value
      : false;
  };

  // const settings = getUserSetting("emailNotifications");
  const [isEnabled, setIsEnabled] = useState(
    getUserSetting("emailNotifications"),
  );

  const [isEnabledForReminder, setIsEnabledForReminder] = useState(
    getUserSetting("reminderNotifications"),
  );

  const [isEnabledForathunication, setIsEnabledForathunication] = useState(
    getUserSetting("2FactorAuthentication"),
  );

  useEffect(() => {
    setIsEnabled(getUserSetting("emailNotifications"));
    setIsEnabledForReminder(getUserSetting("reminderNotifications"));
    setIsEnabledForathunication(getUserSetting("2FactorAuthentication"));
  }, [UserStore.userDetails]);

  return useObserver(() => (
    <div className="mx-2 h-full mb-20 md:pt-[32vh] lg:pt-[23vh] pt-[20vh]">
      <div className="fixed top-0 w-full bg-white z-10">
        <EditIcon onClick={() => setShowLogConfirmationPopup(true)} />
        {/* Navigation Tabs */}
        <ConfirmationPopup
          open={showLogConfirmationPopup}
          onOpenChange={setShowLogConfirmationPopup}
          message={"Do you really want to logout your account?"}
          onConfirm={async () => {
            try {
              await logout();
            } catch (error) {}
            localStorage.clear();
            sessionStorage.clear();
            window.location.replace("/login");
          }}
          confirmButton={"Logout"}
          cancelButton={"Cancel"}
          onCancel={() => setShowLogConfirmationPopup(false)}
        />
        <ConfirmationPopup
          open={showRemoveConfirmationPopup}
          onOpenChange={setShowRemoveConfirmationPopup}
          message={`You really want to remove ${socialMedia[socialMediaIndex]?.platform} Account`}
          onConfirm={() => {
            setShowRemoveConfirmationPopup(false);
            console.log(``);
            //  remove a specific index from socialMedia
            const updatedSocialMedia = socialMedia.filter(
              (_, i) => i !== socialMediaIndex,
            );
            setSocialMedia(updatedSocialMedia);
            // socialMedia.map((media) => console.log(media.platform));
            // setSocialMedia(socialMedia.filter((item) => item !== item.media));
          }}
          confirmButton={"Remove"}
          cancelButton={"Cancel"}
          onCancel={() => setShowRemoveConfirmationPopup(false)}
        />
        <div className="flex tc1:pl-2 -ml-2 sm:px-5 items-center mt-10 space-x-10 md:space-x-24 lg:space-x-24 border-b-2 pl-6 tc1:overflow-x-scroll md:overflow-visible lg:overflow-visible no-scrollbar  ">
          {/* Profile */}
          <div
            className={`flex items-center space-x-3 py-2 min-w-fit cursor-pointer ${
              activeTab === "profile"
                ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
                : "hover:text-primary"
            }`}
            onClick={() => setActiveTab("profile")}
          >
            <CgProfile className="" />
            <label className="cursor-pointer ">Profile</label>
          </div>
          {/* Suscriptions */}
          <div
            className={`flex items-center space-x-3 py-2 min-w-fit cursor-pointer ${
              activeTab === "subcriptions"
                ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
                : "hover:text-primary"
            }`}
            onClick={() => setActiveTab("subcriptions")}
          >
            <AiOutlineDollar className="" />
            <label className="cursor-pointer ">Subscriptions</label>
          </div>
          {/* Credits */}
          {/* <div
            className={`flex items-center space-x-3 py-2 min-w-fit cursor-pointer ${
              activeTab === "credits"
                ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
                : "hover:text-primary"
            }`}
            onClick={() => setActiveTab("credits")}
          >
            <AiOutlineDollar className="" />
            <label className="cursor-pointer ">Credits</label>
          </div> */}
          {/* Your Team */}
          {/* <div
            className={`flex items-center space-x-3 py-2 min-w-fit cursor-pointer ${
              activeTab === "team"
                ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
                : "hover:text-primary"
            }`}
            onClick={() => setActiveTab("team")}
          >
            <GoPeople className="" />
            <label className="cursor-pointer">Your Team</label>
          </div> */}
          {/* More Settings */}
          <div
            className={`flex items-center space-x-3 py-2 min-w-fit cursor-pointer !mr-4 ${
              activeTab === "More settings"
                ? "text-orange-500 border-b-2 border-primary -mb-[1.5px] px-1"
                : "hover:text-primary"
            }`}
            onClick={() => setActiveTab("More settings")}
          >
            <IoSettingsOutline className="" />
            <label className="cursor-pointer">More settings</label>
          </div>
          <div
            onClick={() => setShowLogConfirmationPopup(true)}
            className="hidden md:flex lg:flex text-[#FF6B00] items-center gap-2 !ml-auto !mr-[10vw] cursor-pointer"
          >
            <IoLogOutOutline />
            Logout
          </div>
        </div>
      </div>

      {/* Content for Active Tab */}
      <div className="md:ml-6 lg:ml-6 md:mr-10 mx-2 lg:mr-10 mt-10 md:mt-0">
        {activeTab === "profile" && (
          <div className=" py-5 pt-3 pb-32  px-3 md:px-1">
            <h1 className="pb-5 text-xl font-semibold text-[#000000]">
              Profile Info
            </h1>
            <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
              {formFields.flat().map(
                (field) =>
                  field && (
                    <FormField
                      key={field.id}
                      label={field.label}
                      id={field.id}
                      type={field.type}
                      placeholder={field.placeholder}
                      inputRef={field.ref}
                      disabled={field.disabled}
                      maxLength={field.maxLength}
                      onChange={async (e) => {
                        const timestamp = Date.now().toString();
                        const min = 1000;
                        const max = 9999;
                        const randomNumber =
                          Math.floor(Math.random() * (max - min + 1)) + min;
                        const filename = randomNumber + timestamp;
                        setIsLoading(true);
                        const fileUploaded = await uploadFileToAzure(
                          filename,
                          e.target.files[0],
                          { action: "profile" },
                        );

                        // console.log(fileUploaded.url);
                        const stringifiedURL = JSON.stringify(fileUploaded.url);
                        setProfile(fileUploaded.url);
                        UserStore.setUserPic(fileUploaded.url);
                        let body = { pic: fileUploaded.url };
                        // await UserStore.updateUserDetailsToServer(body).then(
                        //   (res) => {
                        //     console.log(res);
                        //   }
                        // );
                        setIsLoading(false);
                      }}
                    />
                  ),
              )}
              {socialMedia.map((media, index) => {
                return (
                  <div>
                    <label
                      htmlFor="name"
                      className="text-[#888888] font-medium block mb-2"
                    >
                      {media.platform}
                    </label>
                    <div
                      className="flex w-full md:w-[27vw] justify-between items-center pr-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-[#FF6B00]"
                      tabIndex="0"
                    >
                      <input
                        id="name"
                        type="text"
                        placeholder={`spotmies.${media.platform}`}
                        value={media.userId}
                        onChange={(e) => {
                          const updatedSocialMedia = socialMedia.map((item) => {
                            if (item === media) {
                              return { ...item, userId: e.target.value };
                            }
                            return item;
                          });
                          setSocialMedia(updatedSocialMedia);
                        }}
                        className="px-4 py-2 text-[#000000] focus:outline-none w-full rounded-lg"
                      />
                      <MdOutlineDeleteOutline
                        className={`text-[#F63333] text-lg ${
                          media.platform === "Linkedin"
                            ? "cursor-not-allowed"
                            : "cursor-pointer"
                        }`}
                        onClick={() => {
                          setShowRemoveConfirmationPopup(true);
                          setSocialMediaIndex(index);
                        }}
                      />
                    </div>
                  </div>
                );
              })}

              <AnotherAccount
                buttonName={`Add ${
                  socialMedia.length < 1 ? "Social Media" : "Another"
                } Account`}
                onClick={() => {
                  setShowSocialMediaPopup(true);
                }}
              />

              {showSocialMediaPopup && (
                <Socialmediapopup
                  buttonName={`Add Account`}
                  onClick={(data) => {
                    if (
                      socialMedia.find(
                        (item) => item.platform === data.platform,
                      )
                    ) {
                      alert("Account already exists");
                      return;
                    }
                    const updatedSocialMedia = [...socialMedia, data];
                    setSocialMedia(updatedSocialMedia);
                    setShowSocialMediaPopup(false);
                  }}
                  closePopup={() => setShowSocialMediaPopup(false)}
                />
              )}
              {showConfirmationPopup && (
                <ConfirmationPopup
                  message={"Do you really want to remove Instagram Account?"}
                  onConfirm={() => setShowConfirmationPopup(false)}
                  cancelButton={"Remove"}
                  onCancel={() => setShowConfirmationPopup(false)}
                />
              )}
            </div>
            <SaveChanges buttonName={"Save Changes"} onClick={submitHandler} />
          </div>
        )}

        {activeTab === "subcriptions" && (
          <div>
            <PreviousSubscription subscriptions={subscriptions} />
          </div>
        )}

        {activeTab === "credits" && (
          <div>
            {/* <TotalCredits /> */}
            <ViewCredits />
          </div>
        )}

        {activeTab === "team" && (
          <>
            <div className="flex flex-row md:mt-6 lg:mt-6 mt-5 mb-5 justify-between items-center">
              <h2 className="text-[#000000] text-xl w font-semibold ">
                Team Members
              </h2>
              <div>
                <AddMember
                  buttonName={"Add Member"}
                  onClick={() => setShowAddNumberPopup(true)}
                />
                {showAddNumberPopup && (
                  <Addnumber
                    buttonName={"Add"}
                    onClick={() => {
                      setShowAddNumberPopup(false);
                    }}
                  />
                )}
              </div>
            </div>
            <TeamsTable />
          </>
        )}

        {activeTab === "More settings" && (
          <div>
            <h2 className="text-black text-xl md:mb-5 lg:mb-5 mb-2 mt-3 font-bold">
              Additional Settings
            </h2>
            <div className="flex md:flex-row lg:flex-row flex-col ml-0 gap-4 w-full md:pd-0 lg:pd-0 pb-4 ">
              <NotificationSettingComponent
                title={"Email Notifications"}
                description={
                  "Control alerts for new candidate submissions, interviews, and messages."
                }
                Enabled={isEnabled}
                onChange={async () => {
                  try {
                    const currentUser = UserStore.userDetails;
                    const currentSettings =
                      currentUser?.additionalSettings || [];

                    // Create new settings array
                    const newSettings = currentSettings.filter(
                      (setting) => setting?.name !== "emailNotifications",
                    );

                    // Add the new setting with toggled value
                    newSettings.push({
                      name: "emailNotifications",
                      value: !isEnabled,
                    });

                    // Update the settings
                    const res = await UserStore.UpdateUserStatus({
                      additionalSettings: newSettings,
                    });

                    if (res) {
                      const updatedUser = {
                        ...currentUser,
                        additionalSettings: newSettings,
                      };
                      UserStore.setUserDetails(updatedUser);
                      setIsEnabled(!isEnabled);
                    }
                  } catch (error) {
                    console.error(
                      "Error updating notification settings:",
                      error,
                    );
                  }
                }}
              />

              <NotificationSettingComponent
                title={"Reminder Notifications"}
                description={
                  "Configure reminders for pending interviews or tasks"
                }
                Enabled={
                  Array.isArray(UserStore.userDetails?.additionalSettings) &&
                  UserStore.userDetails?.additionalSettings?.find(
                    (setting) => setting?.name === "reminderNotifications",
                  )?.value
                }
                onChange={async () => {
                  let additionalSettings = Array.isArray(
                    UserStore.userDetails?.additionalSettings,
                  )
                    ? UserStore.userDetails?.additionalSettings
                    : [];
                  additionalSettings = additionalSettings?.filter(
                    (setting) => setting?.name !== "reminderNotifications",
                  );
                  additionalSettings.push({
                    name: "reminderNotifications",
                    value:
                      !UserStore.userDetails?.additionalSettings?.find(
                        (setting) => setting?.name === "reminderNotifications",
                      )?.value ?? false,
                  });
                  const res = await UserStore.UpdateUserStatus({
                    additionalSettings: additionalSettings,
                  });
                  if (res) {
                    setIsEnabledForReminder(
                      UserStore.userDetails.additionalSettings?.find(
                        (setting) => setting?.name === "reminderNotifications",
                      )?.value ?? false,
                    );
                  }
                }}
              />

              <NotificationSettingComponent
                title={"Enable 2 Factor Authentication"}
                description={
                  "Control alerts for new candidate submissions, interviews, and messages."
                }
                Enabled={
                  Array.isArray(UserStore.userDetails?.additionalSettings) &&
                  UserStore.userDetails?.additionalSettings?.find(
                    (setting) => setting?.name === "2FactorAuthentication",
                  )?.value
                }
                onChange={async () => {
                  let additionalSettings = Array.isArray(
                    UserStore.userDetails?.additionalSettings,
                  )
                    ? UserStore.userDetails?.additionalSettings
                    : [];
                  additionalSettings = additionalSettings?.filter(
                    (setting) => setting?.name !== "2FactorAuthentication",
                  );
                  additionalSettings.push({
                    name: "2FactorAuthentication",
                    value:
                      !UserStore.userDetails?.additionalSettings?.find(
                        (setting) => setting?.name === "2FactorAuthentication",
                      )?.value ?? false,
                  });
                  const res = await UserStore.UpdateUserStatus({
                    additionalSettings: additionalSettings,
                  });
                  if (res) {
                    setIsEnabledForathunication(
                      UserStore.userDetails.additionalSettings?.find(
                        (setting) => setting?.name === "2FactorAuthentication",
                      )?.value ?? false,
                    );
                  }
                }}
              />
            </div>
            <div className="flex flex-col">
              {user?.loginType === "email" && <ChangePasswordForm />}
              {/* <DisableAccount /> */}
              <DeleteAccount />
            </div>
          </div>
        )}
      </div>
    </div>
  ));
};

export default ProfilePage1;
